export const GET_UNIVERSITIES_STRUCTURES = 'GET_UNIVERSITIES_STRUCTURES'
export const GET_UNIVERSITIES_STRUCTURES_SUCCESS = 'GET_UNIVERSITIES_STRUCTURES_SUCCESS'
export const GET_UNIVERSITIES_STRUCTURES_ERROR = 'GET_UNIVERSITIES_STRUCTURES_ERROR'

export const ADD_UNIVERSITY_STRUCTURE = 'ADD_UNIVERSITY_STRUCTURE'
export const ADD_UNIVERSITY_STRUCTURE_SUCCESS = 'ADD_UNIVERSITY_STRUCTURE_SUCCESS'
export const ADD_UNIVERSITY_STRUCTURE_ERROR = 'ADD_UNIVERSITY_STRUCTURE_ERROR'

export const EDIT_UNIVERSITY_STRUCTURE = 'EDIT_UNIVERSITY_STRUCTURE'
export const EDIT_UNIVERSITY_STRUCTURE_SUCCESS = 'EDIT_UNIVERSITY_STRUCTURE_SUCCESS'
export const EDIT_UNIVERSITY_STRUCTURE_ERROR = 'EDIT_UNIVERSITY_STRUCTURE_ERROR'

export const DELETE_UNIVERSITY_STRUCTURE = 'DELETE_UNIVERSITY_STRUCTURE'
export const DELETE_UNIVERSITY_STRUCTURE_SUCCESS = 'DELETE_UNIVERSITY_STRUCTURE_SUCCESS'
export const DELETE_UNIVERSITY_STRUCTURE_ERROR = 'DELETE_UNIVERSITY_STRUCTURE_ERROR'

export const APPROVED_UNIVERSITY_STRUCTURE = 'APPROVED_UNIVERSITY_STRUCTURE'
export const APPROVED_UNIVERSITY_STRUCTURE_SUCCESS = 'APPROVED_UNIVERSITY_STRUCTURE_SUCCESS'
export const APPROVED_UNIVERSITY_STRUCTURE_ERROR = 'APPROVED_UNIVERSITY_STRUCTURE_ERROR'

export const GET_FACULTIES_STRUCTURES = 'GET_FACULTIES_STRUCTURES'
export const GET_FACULTIES_STRUCTURES_SUCCESS = 'GET_FACULTIES_STRUCTURES_SUCCESS'
export const GET_FACULTIES_STRUCTURES_ERROR = 'GET_FACULTIES_STRUCTURES_ERROR'

export const ADD_FACULTY_STRUCTURE = 'ADD_FACULTY_STRUCTURE'
export const ADD_FACULTY_STRUCTURE_SUCCESS = 'ADD_FACULTY_STRUCTURE_SUCCESS'
export const ADD_FACULTY_STRUCTURE_ERROR = 'ADD_FACULTY_STRUCTURE_ERROR'

export const EDIT_FACULTY_STRUCTURE = 'EDIT_FACULTY_STRUCTURE'
export const EDIT_FACULTY_STRUCTURE_SUCCESS = 'EDIT_FACULTY_STRUCTURE_SUCCESS'
export const EDIT_FACULTY_STRUCTURE_ERROR = 'EDIT_FACULTY_STRUCTURE_ERROR'

export const DELETE_FACULTY_STRUCTURE = 'DELETE_FACULTY_STRUCTURE'
export const DELETE_FACULTY_STRUCTURE_SUCCESS = 'DELETE_FACULTY_STRUCTURE_SUCCESS'
export const DELETE_FACULTY_STRUCTURE_ERROR = 'DELETE_FACULTY_STRUCTURE_ERROR'

export const APPROVED_FACULTY_STRUCTURE = 'APPROVED_FACULTY_STRUCTURE'
export const APPROVED_FACULTY_STRUCTURE_SUCCESS = 'APPROVED_FACULTY_STRUCTURE_SUCCESS'
export const APPROVED_FACULTY_STRUCTURE_ERROR = 'APPROVED_FACULTY_STRUCTURE_ERROR'

export const GET_SPECIALITIES_STRUCTURES = 'GET_SPECIALITIES_STRUCTURES'
export const GET_SPECIALITIES_STRUCTURES_SUCCESS = 'GET_SPECIALITIES_STRUCTURES_SUCCESS'
export const GET_SPECIALITIES_STRUCTURES_ERROR = 'GET_SPECIALITIES_STRUCTURES_ERROR'

export const ADD_SPECIALITY_STRUCTURE = 'ADD_SPECIALITY_STRUCTURE'
export const ADD_SPECIALITY_STRUCTURE_SUCCESS = 'ADD_SPECIALITY_STRUCTURE_SUCCESS'
export const ADD_SPECIALITY_STRUCTURE_ERROR = 'ADD_SPECIALITY_STRUCTURE_ERROR'

export const EDIT_SPECIALITY_STRUCTURE = 'EDIT_SPECIALITY_STRUCTURE'
export const EDIT_SPECIALITY_STRUCTURE_SUCCESS = 'EDIT_SPECIALITY_STRUCTURE_SUCCESS'
export const EDIT_SPECIALITY_STRUCTURE_ERROR = 'EDIT_SPECIALITY_STRUCTURE_ERROR'

export const DELETE_SPECIALITY_STRUCTURE = 'DELETE_SPECIALITY_STRUCTURE'
export const DELETE_SPECIALITY_STRUCTURE_SUCCESS = 'DELETE_SPECIALITY_STRUCTURE_SUCCESS'
export const DELETE_SPECIALITY_STRUCTURE_ERROR = 'DELETE_SPECIALITY_STRUCTURE_ERROR'

export const APPROVED_SPECIALITY_STRUCTURE = 'APPROVED_SPECIALITY_STRUCTURE'
export const APPROVED_SPECIALITY_STRUCTURE_SUCCESS = 'APPROVED_SPECIALITY_STRUCTURE_SUCCESS'
export const APPROVED_SPECIALITY_STRUCTURE_ERROR = 'APPROVED_SPECIALITY_STRUCTURE_ERROR'